import pluralize from 'pluralize';

import { StatusFilterValue } from '@/components/ui/data-table/status-filter';
import { STATUS_FILTER_TYPES } from '@/lib/constants';

export const statusToString = (status?: StatusFilterValue): string | undefined => {
  if (!status || !status.type) return undefined;

  const baseString =
    `More than ${status.time ? status.time : ''} ${status.basis ? pluralize(status.basis, parseInt(status.time || '0', 10)) : ''} ${status.type}`.trim();

  switch (status.type) {
    case STATUS_FILTER_TYPES.AHEAD:
      if (status.time) {
        return `${baseString} of schedule`;
      }
      return 'Ahead of schedule';
    case STATUS_FILTER_TYPES.DELAYED:
      if (status.time) {
        return baseString;
      }
      return 'Delayed';
    case STATUS_FILTER_TYPES.DISCHARGED:
      return 'Shipment is discharged';
    case STATUS_FILTER_TYPES.TRANSIT:
      return 'Shipment is in transit';
    case STATUS_FILTER_TYPES.DESTINATION:
      return 'Shipment is at destination';
    case STATUS_FILTER_TYPES.AWAITING_TRANSSHIPMENT:
      return 'Shipment is awaiting transshipment';
    default:
      return undefined;
  }
};
